export const GAME_SHOT_CHARTS = {
  ENTITY_LOGO_SIZE: 32,
  SELECTOR_PLAYER_LOGO_SIZE: 38,
  COURT_RATIO_BASKETBALL: 1.86,
  COURT_RATIO_FOOTBALL: 1.58,
  BASKETBALL_LINE_OFFSET: 0.948,
  SHALLOW_SHOT_MAP_PLAYER_LOGO_SIZE: 64,

  SHOTS_OFFSET: {
    line: 0.95,
    side: 0.955,
  },

  OUTCOME_IDS: {
    goal: 0,
    block: 4,
  },

  OUTCOME_SUBTYPES: {
    ownGoal: 10
  },

  ACTION_TYPES: {
    onStatusChange: 'onStatusChange',
    onShotStatusChange: 'onShotStatusChange',
    onPlayerSelected: 'onPlayerSelected',
    onCollapseButtonClick: 'onCollapseButtonClick',
    onPlayerPopupClick: 'onPlayerPopupClick',
    onShotSelected: 'onShotSelected'
  },

  COURT_SIZES_OFFSET: {
    FOOTBALL: {
      desktop: 16,
      mobile: 0
    },

    BASKETBALL: {
      desktop: 0,
      mobile: 16
    }
  },

  RADIUS: {
    shot: 6,
    animation: 8
  },

  SHOT_TYPE: {
    made: 0,
    miss: 1
  },

  ANALYTICS: {
    ACTION_TYPES: {
      onDisplay: 'onDisplay',
      onTabClick: 'onTabClick',
      onShowClick: 'onShowClick',
      onToggleClick: 'onToggleClick',
      onPlayerClick: 'onPlayerClick',
      onShotClick: 'onShotClick',
      onShotSwipe: 'onShotSwipe'
    },

    OUTCOME: {
      goal: 0,
      missed: 1,
      attemptSaved: 2,
      ownGoal: 3
    }
  },

  EVENT_DETAILS_KEYS: {
    situation: 0,
    bodyPart: 1,
    penaltyMinute: 2,
    penaltyShot: 3,
    xg: 4,
    xGot: 5
  },

  DIRECTIONS: {
    prev: 'prev',
    next: 'next'
  },
}
